import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { UTILITIES } from './../../core/utility/utilities';
import moment from "moment";
import { message, CONSTANTS, ProfileInfo, APIS } from './../../core/constants/constants';
import { AppService } from './../../app.service';
import { InAppService } from './../../inapp.service';
import * as firebase from "firebase";
import { WindowRefService } from './../../window-ref.service';
import { Device } from '@ionic-native/device/ngx';
declare const RazorpayCheckout: any;

@Component({
  selector: 'app-payment-subscribe-popup',
  templateUrl: './payment-subscribe-popup.component.html',
  styleUrls: ['./payment-subscribe-popup.component.scss'],
})

export class PaymentSubscribePopupComponent implements OnInit {

  subscribe: any = {};
  @Input() content: string;
  @Input() onClose: string;
  @Input() totalScore: string;
  suggestedCalories;
  targetCalories = 0;
  targetDietCalories = 0;
  bmrCalories = 0;
  activitySteps = 0;
  calculateActivity = 0;
  mealTimeDifference = 0;
  mealFastingTimeDifference= 0;
  differenceHours= 0;
  fastingTimeSlot = "";
  mealTimeSlot = "";
  constructor(public modalController: ModalController, private router: Router, 
    private utilities: UTILITIES, private storage: Storage,
    private appService: AppService,
    private platform: Platform,
    private inapp: InAppService,
    private winRef: WindowRefService,
    private device: Device,) { }
  
  userCalories = "";
  diets;
  meal={
    morning:'',
    night:''
  };
  isOfferActive = false;
  plan;
  data;
  country = "IND";
  totalCalories;
  carbs;
  protein;
  fat;
  canvasWidth = 200;
  needleValue= 50;
  centralLabel = '';
  readyForChange = true;
  options = {
    hasNeedle: true,
    needleColor: 'black',
    needleUpdateSpeed: 1000,
    arcColors: ["#0BB852", "#FFF", "#8BC73C", "#FFF", "#FFAE00", "#FFF", "#FF791F", "#FFF", "#FF2441"],
    arcDelimiters: [14, 15, 29, 30, 49, 50, 74, 75],
    needleStartValue: 0,
  }

  ionViewDidEnter(){
    this.utilities.hideLoader();
    setInterval(()=>{
      this.needleValue = Math.floor(Math.random() * 100);
    }, 2000);
  }
  ionViewWillEnter(){
    let count = localStorage.getItem("couponCounter");
    let typeEevnt = this.content.replace(" ","_" );
    this.utilities.logEvent("popup_"+typeEevnt, {});
    let coutDownTimer = localStorage.getItem("offerTimeExpired");
    // this.appService.getCurrentLocation().then(
    // (location: any) => {
      this.country = CONSTANTS.country == "IND" ? "IND" : "Non-IND";
      if (Number(count) >= 1 && coutDownTimer == "false") {
        this.isOfferActive = true;
        this.countDown();
      }else{
        this.isOfferActive = false;
      }
    // })
    
    
    // this.storage.get("localData").then(val => {
    //   let data  = this.utilities.parseJSON(val);
      // this.userCalories = data["otherMaster"]["calories"]["calories"];
      // this.storage.get("profileData").then(val1 => {
      //   let profile  = this.utilities.parseJSON(val1);
      //   this.userCalories = profile["lifeStyle"]["calories"];
      //   this.setContent();
      // })
    // })

    if(this.content == 'deficit'){
      this.storage.get("dietData").then(val => {
        this.storage.get("caloriesFit").then((res)=>{
          this.targetCalories = Math.round(Number(res.targetCaloriesToBurn));
          this.activitySteps =  Math.round(Number(res.activityLevels));
          this.calculateActivity = Math.round(Number(res.activityLevels) * 4 /100);
          let todayDate = moment(new Date()).format("DDMMYYYY")
          let planName = CONSTANTS.isDetox ? "detox" : CONSTANTS.selectedDietPlan;
          this.suggestedCalories = Math.round(val[todayDate][planName]["tolalCalories"]);
          this.setContent();
        })
        // let data = JSON.parse(val);
        // this.suggestedCalories = 
        
      })
    }else if(this.content == 'fasting'){
      this.storage.get("diets").then(diets => {
        this.diets=diets;
       this.meal.morning =  this.tConvert(this.diets.find(o=>o.slot ==1).time);
        this.meal.night =  this.diets.find(o=>o.slot ==8).time ?
        this.tConvert(this.diets.find(o=>o.slot ==8).time) : 
        this.tConvert(this.diets.find(o=>o.slot ==7).time);
        this.differenceHours = Number(localStorage.getItem("mealDifferenceHours"));
        this.mealFastingTimeDifference = 24 - Number(this.differenceHours);
        this.mealFastingTimeDifference = this.differenceHours;
        this.mealTimeDifference = 24 - Number(this.differenceHours);
        let isFastingAM = this.meal.morning.indexOf('AM') > -1 ? this.meal.morning : this.meal.morning + ' AM';
        let isMealTimeAM = this.meal.morning.indexOf('AM') > -1 ? this.meal.morning : this.meal.morning + ' AM';
        this.fastingTimeSlot = this.meal.night + " - " + isFastingAM;
        this.mealTimeSlot = isMealTimeAM + " - " + this.meal.night;
        this.setContent();
      });
    }else{
      this.setContent();
    }
    
  }

  countdownTimerText;
  countdownMins; 
  countdownSec; 
  countDown(){
    let deadline = new Date(localStorage.getItem("countDownTimer")).getTime();
    
    let self = this;
    let x = setInterval(function () {
      let now = new Date().getTime();
      let t = deadline - now;
      if (t < 0) {
        clearInterval(x);
        console.log("offer page");
        localStorage.setItem("offerTimeExpired", "true");
        self.close(false);
        return false;
      }

      let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((t % (1000 * 60)) / 1000);

      self.countdownMins = (minutes <= 9 ? "0" + minutes : minutes);
      self.countdownSec = (seconds <= 9 ? "0" + seconds : seconds);
      self.countdownTimerText = (minutes <= 9 ? "0" + minutes : minutes) + ":" + (seconds <= 9 ? "0" + seconds : seconds);
    }, 1000);
  }

  tConvert (time) {
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  
    if (time.length > 1) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
  }

  setContent(){
    switch (this.content) {
      case 'deficit':
        this.subscribe = {
          title: "Calories Deficit",
          coloredtitle: "",
          quote: "It is the key to weight loss !",
          bullets: [
            { title: "Calories deficit is the difference between calories burnt by you & calories you consume" },
            { title: "We are the only app with this tracker." },
            { title: "Each day 500 calories deficit is recommended" },
            { title: "For today, the calories target for you is "+ this.targetCalories + " (considering targe of "+this.activitySteps+ " steps) and as per diet plan the calories consumed will be " + this.suggestedCalories + ". So Calories Deficit will be "+ (this.targetCalories - this.suggestedCalories)}
          ],
          img: "./assets/img/deficit-story-3.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'update diet plan':
        this.subscribe = {
          title: "Update ",
          coloredtitle: "Diet Plan",
          quote: "Update healthy items as per your taste",
          bullets: [
            { title: "“Other Options” displays list of the healthy options" },
            {
              title: "You can discover best healthy options by -",
              subpoints: [
                "Dark green color the best ones & orange average ones",
                "Heart icon indicating recommended for lifestyle disorder",
                "Find low calories / high protein / low fat ones"
              ]
            },
            { title: "Update the plan with appropriate portion size." }
          ],
          img: "./assets/img/dietplan-story-2.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'food detail':
        this.subscribe = {
          title: "Food Details",
          coloredtitle: "",
          quote: "Know all about your food item",
          bullets: [
            { title: "We give you healthy recipes for each food item ." },
            { title: "You can update quantity, replace item or delete the item from your diet plan" },
            { title: "We also recommend similar healthy options for replacing current one" }
          ],
          img: "./assets/img/deficit-story-1.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'fasting':
        this.subscribe = {
          title: "Fasting",
          coloredtitle: "",
          quote: "Age old secret to keep yourself healthy",
          bullets: [
            { title: "In the app your Fasting Window is of "+ this.mealFastingTimeDifference +" hours from "+ this.fastingTimeSlot +"" },
            { title: "In the app your Eating Window is of "+ this.mealTimeDifference +" hours from  "+this.mealTimeSlot+"" },
            { title: "We track the % of your fasting completed in a visually appealing way." },
            { title: "You can edit fasting & meal timings" }
          ],
          img: "./assets/img/fasting-story-2.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'keymantras':
        this.subscribe = {
          title: "Follow Key Mantras",
          coloredtitle: "",
          quote: "We make habits & habits make us.",
          bullets: [
            { title: "In the app we recommend simple healthy habits to follow" },
            { title: "Each day we capture that which of the habits are being followed" },
            { title: "Based on this data we will soon start sharing smart recommendations" }
          ],
          img: "./assets/img/dietplan-story-4.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'weightloss':
        this.subscribe = {
          title: "Weight Loss",
          coloredtitle: "",
          quote: "The secret of losing weight is patience.",
          bullets: [
            { title: "We recommend losing 0.5 to 1kg each week." },
            { title: "We gave a weight tracker to monitor your journey." },
            { title: "If you follow us we assure you to lose weight." }
          ],
          img: "./assets/img/deficit-story-2.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'diet plan analysis':
        this.subscribe = {
          title: "Diet Plan Analysis",
          coloredtitle: "",
          quote: "Get all info & score of your diet plan",
          bullets: [
            {title: "Your Diet Score is " + this.totalScore+"%"},
            {
              title: "We score your diet based on",
              subpoints: [
                "How much to eat, based on calories recommended",
                "What to eat,  based on nutrients needed and lifestyle disorders",
                "When to eat, based on circadian rhythm"
              ]
            },
            { title: "We alert you with red ! icon if any value exceeds the limit." }
          ],
          img: "./assets/img/dietplan-story-1.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'special reco':
        this.subscribe = {
          title: "Special Recommendations",
          coloredtitle: "",
          quote: "Update plan with your special food items",
          bullets: [
            { title: "We display your list of healthy, low calories and high protein items" },
            { title: "Click the + icon to update the diet plan with the food items preferred by you." },
            { title: "Food item added of same category replaces the existing item" }

          ],
          img: "./assets/img/other-food-item.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'unlock your diet plan':
        this.subscribe = {
          title: "Unlock your ",
          coloredtitle: "Diet plan",
          quote: "Discover your own diet plan",
          bullets: [
            { title: "We are ready with today diet plan of " + this.totalCalories + "  calories." },
            { title: "It has " + this.carbs + " gm of carbs, " + this.protein + " gm of protein and " + this.fat + " gm fats which are in recommended range." },
            { title: "No need to Count Calories separately. Update diet plan from healthy options." },
            { title: "Best options are marked dark green, try to choose from those." }

          ],
          img: "./assets/img/lock-payment-popup.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
      case 'nutri diet plan':
        this.subscribe = {
          isGauge: true,
          title: "Unlock your ",
          coloredtitle: "Diet plan",
          quote: "Check how healthy your food is!",
          dataTitle: "Nutricheck helps you to know relative ranking of food item based on following criterions :",
          dataLastText: "Provides  generic guidelines for healthy living and also for weight management. Dark greens are the best one to consume and Red needs to be avoided.",
          bullets: [
            { title: "Carbohydrates" },
            { title: "Protein" },
            { title: "Fiber" },
            { title: "Calories Density" }
          ],
          img: "./assets/img/lock-payment-popup.jpg",
          plan: "6 Months Plan",
          planPrice: 899,
          popularPlan: "Most popular plan",
          viewAll: "View all the plans"
        }
        break;
    }
  }


  ngOnInit() {
    // this.content == 
    
  }

  goToUpgrade(){
    this.modalController.dismiss();
    this.router.navigate(["upgrade-plan"]);
  }

  close(fag) {
    this.modalController.dismiss();
    // if (this.onClose) {
    //   this.router.navigate([this.onClose]);
    // }
  }

  doUpgrade(){
    let data = this.plan;
    this.modalController.dismiss(data);
  }
}
